import React, { useEffect, useState } from "react";
import { Modal } from "../../..";
import { Button, CopyValue, Loader, Toast } from "../../..";
import { FiDownload } from "react-icons/fi";
import "swiper/css";
import "swiper/css/navigation";
import { apis, get } from "../../../../Utils/axios";
import BookedFor from "./bookedFor";
import { useClientSettings } from "Hooks/useClientSettings";
import { formatedPrice } from "Utils/utils";

function CabBooking({ bookingId, onClose = () => {} }) {
	const { currency } = useClientSettings();
	const [Loading, setLoading] = useState(true);
	const [Booking, setBooking] = useState({});
	const { id, amount, pickupTime, pickup, drop, variant, type, booking, status, passengers, bookingId: confirmationId } = Booking;

	useEffect(() => {
		if (bookingId) {
			fetchBooking(bookingId);
		}
	}, [bookingId]);

	const fetchBooking = (bookingId) => {
		setLoading(true);
		get(apis.getCabBookingDetails, { bookingId }, (r, e) => {
			if (r) {
				setBooking(r);
				setLoading(false);
			} else if (e) {
				Toast.handleError(e);
				setLoading(false);
			}
		});
	};

	return (
		<Modal open={bookingId} onClose={onClose} contentClass="!max-w-[40%]">
			<Loader loading={Loading} />
			<div className="p-4 rounded-lg bg-light">
				<div className="rounded-lg shadow-md bg-canvas">
					<div className="grid grid-cols-2 gap-4 p-6">
						<div className="text-xs font-semibold">
							<div className="text-label">Pickup Point</div>
							<div>{pickup}</div>
						</div>
						<div className="text-xs font-semibold">
							<div className="text-label">Drop Point</div>
							<div>{drop}</div>
						</div>
						<div className="text-xs font-semibold">
							<div className="text-label">Confirmation ID</div>
							<CopyValue>{confirmationId}</CopyValue>
						</div>
						<div className="text-xs font-semibold">
							<div className="text-label">Cab Type</div>
							<div>{variant}</div>
						</div>
						<div className="text-xs font-semibold">
							<div className="text-label">Booking ID</div>
							<CopyValue>CAB-{bookingId}</CopyValue>
						</div>
						<div className="text-xs font-semibold">
							<div className="text-label">Amount</div>
							<div>
								{currency} {formatedPrice(amount)}
							</div>
						</div>
					</div>
				</div>
				<BookedFor type="stay" bookingId={bookingId} travellers={passengers} onReload={() => fetchBooking(bookingId)} />
				<div className="flex mt-4 gap-x-2">
					<Button variant="outlined" className="flex-grow">
						<FiDownload className="mr-2" />
						Download Booking
					</Button>
					<Button variant="danger" className="flex-grow">
						Cancel Booking
					</Button>
				</div>
			</div>
		</Modal>
	);
}

export default CabBooking;
